import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {number} breakPoint
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

export const MainMenu = {
    breakPoint: 992,
    selector: '.nav_container',
    navButton: 'header .nav-button',
    // overlay: {
    //     element: '#nav-overlay',
    //     close: '#nav-close',
    // },
};

onDomReady(() => {
    new DropdownMenu(MainMenu);
});
